import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/slack': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M94.1 315.1c0 25.9-21.2 47.1-47.1 47.1-25.9 0-47.1-21.2-47.1-47.1 0-25.9 21.2-47.1 47.1-47.1h47.1v47.1zM117.8 315.1c0-25.9 21.2-47.1 47.1-47.1 25.9 0 47.1 21.2 47.1 47.1v117.8c0 25.9-21.2 47.1-47.1 47.1-25.9 0-47.1-21.2-47.1-47.1v-117.8zM164.9 126.1c-25.9 0-47.1-21.2-47.1-47.1 0-25.9 21.2-47.1 47.1-47.1 25.9 0 47.1 21.2 47.1 47.1v47.1h-47.1zM164.9 149.8c25.9 0 47.1 21.2 47.1 47.1 0 25.9-21.2 47.1-47.1 47.1h-117.8c-25.9 0-47.1-21.2-47.1-47.1 0-25.9 21.2-47.1 47.1-47.1h117.8zM353.9 196.9c0-25.9 21.2-47.1 47.1-47.1 25.9 0 47.1 21.2 47.1 47.1 0 25.9-21.2 47.1-47.1 47.1h-47.1v-47.1zM330.2 196.9c0 25.9-21.2 47.1-47.1 47.1-25.9 0-47.1-21.2-47.1-47.1v-117.8c0-25.9 21.2-47.1 47.1-47.1 25.9 0 47.1 21.2 47.1 47.1v117.8zM283.1 385.9c25.9 0 47.1 21.2 47.1 47.1 0 25.9-21.2 47.1-47.1 47.1-25.9 0-47.1-21.2-47.1-47.1v-47.1h47.1zM283.1 362.2c-25.9 0-47.1-21.2-47.1-47.1 0-25.9 21.2-47.1 47.1-47.1h117.8c25.9 0 47.1 21.2 47.1 47.1 0 25.9-21.2 47.1-47.1 47.1h-117.8z'
      }
    ]
  }
})
